import Field2 from "../form/Field2";
import SearchIcon from "icons/searchIcon.svg";
import {
  Checkbox,
  Container,
  Truncate,
  Typography,
} from "src/components/ct-design";

import ViewMore from "icons/viewMorePlus.svg";
import ViewLess from "icons/viewLessMinus.svg";
import "./styles.scss";

import {
  ChangeEvent,
  FunctionComponent,
  useEffect,
  useMemo,
  useState,
} from "react";
import { FilterList } from "src/containers/results/types";
import classNames from "classnames";

interface MultiSelectListProps {
  data: FilterList[];
  showIcon?: boolean;
  listTitle: string;
  handleSelect: (item: FilterList, type: string) => void;
  type: string;
}

const MultiSelectList: FunctionComponent<MultiSelectListProps> = (props) => {
  const { data, showIcon, handleSelect, type, listTitle } = props;
  const [showMore, setShowMore] = useState(false);
  const [isLargeList, setisLargeList] = useState(
    data?.length >= 5 ? true : false
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [focus, setFocus] = useState(false);

  useEffect(() => {
    setisLargeList(data?.length >= 5 ? true : false);
  }, [data]);

  const getListData = useMemo(() => {
    if (data) {
      let list = [];
      if (isLargeList && !showMore) {
        list = [...data]?.filter((item, index) => index < 5);
      } else list = [...data];
      if (searchTerm !== "") {
        const newlist = [...data].filter((item) =>
          (item.value as string)
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
        );
        return newlist;
      }
      return list;
    }
    return [];
  }, [data, isLargeList, searchTerm, showMore]);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const target = e.target;
    setSearchTerm(target.value);
  };

  const error = useMemo(
    () => searchTerm && !getListData.length,
    [searchTerm, getListData]
  );

  const getHeight = useMemo(() => {
    if (!error) {
      if (searchTerm) return "auto";
      else if (!showMore) {
        if (type === "amenities")
          return getListData?.length > 4 ? "245px" : "auto";
        else return getListData?.length > 4 ? "240px" : "auto";
      } else return "440px";
    } else return "0px";
  }, [error, getListData?.length, searchTerm, showMore, type]);

  const wrapperClassName = classNames(
    "multiSelectList",
    error ? "pb-2" : "pb-4"
  );
  return (
    <>
      <div className={wrapperClassName}>
        <Field2
          placeholder="Search"
          Icon={SearchIcon}
          value={searchTerm}
          onChange={handleSearch}
          iconClass={focus ? "fill-orange" : "fill-grey"}
          onFocus={() => {
            setFocus(true);
          }}
          onBlur={() => setFocus(false)}
        />

        {error ? (
          <Typography className="ml-4 mt-2" variant="B2" color="warning">
            No {listTitle.toLowerCase()} found
          </Typography>
        ) : null}

        <div
          className={error ? "" : "mt-4"}
          style={{
            overflowY: "auto",
            height: getHeight,
            // overflowX: "hidden",
          }}
        >
          {getListData?.map((item, index) => {
            if (item?.title.length)
              return (
                <Container
                  key={index}
                  className=" w-100p  py-2 c-pointer"
                  onClick={() => handleSelect(item, type)}
                >
                  <Container
                    className="w-100p flex"
                    css={{ padding: "2px 0px" }}
                  >
                    <Checkbox
                      key={index}
                      checked={item.selected}
                      onClick={() => {}}
                      disabled={false}
                      style={{
                        width: "100%",
                      }}
                    />
                    <Container className="flex flex-middle truncate w-100p">
                      {showIcon ? (
                        <div className="mr-2 h-6">{item.icon}</div>
                      ) : null}
                      <Truncate width="95%" className="fw-400 fs-14 lh-20">
                        {item.title}
                      </Truncate>
                    </Container>
                  </Container>
                </Container>
              );
          })}
          {isLargeList && !searchTerm ? (
            <div
              className="flex flex-middle py-2 c-pointer"
              onClick={() => setShowMore((prev) => !prev)}
            >
              {!showMore ? <ViewMore /> : <ViewLess />}
              <Typography variant="L2" className="ml-2" colorCode="#0F6BFF">
                {!showMore ? `Show all (${data.length})` : "Show less"}
              </Typography>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default MultiSelectList;
